export const WebSocketMixins = {
    data() {
        return {
            websocket: null,
            heartTimer: null,
        };
    },
    methods: {
        initWebSocket(path) {
            if (!path) return;
            const username = localStorage.getItem('username');
            if (!username) return;

            // 防止重复连接
            if (this.websocket && this.websocket.readyState === WebSocket.OPEN) {
                console.log("WebSocket [" + path + "] 已连接");
                return;
            }

            const wsUrl = `${window._CONFIG['webSocket']}${path}:${username}`;
            this.websocket = new WebSocket(wsUrl);

            this.websocket.onopen = () => {
                console.log("WebSocket [" + path + "] 连接成功");
                this.startHeartCheck();
            };

            this.websocket.onerror = () => {
                console.log("WebSocket [" + path + "] 连接失败");
            };

            this.websocket.onmessage = (e) => {
                console.log("接收数据:", e.data);
                this.onSocketMessage(e);
                this.resetHeartCheck();
                this.startHeartCheck();
            };

            this.websocket.onclose = () => {
                console.log("WebSocket [" + path + "] 连接已关闭");
                this.stopHeartCheck();
            };
        },

        // 这个方法留给组件覆写
        onSocketMessage(e) {
            try {
                const data = JSON.parse(e.data);
                this.$notification[data.status]?.({
                    message: data.message,
                    description: data.description,
                    duration: null
                });
            } catch (err) {
                console.warn("WebSocket 消息解析失败:", err);
            }
        },

        resetHeartCheck() {
            if (this.heartTimer) {
                clearInterval(this.heartTimer);
                this.heartTimer = null;
            }
        },

        startHeartCheck() {
            this.resetHeartCheck();
            this.heartTimer = setInterval(() => {
                if (this.websocket && this.websocket.readyState === WebSocket.OPEN) {
                    this.websocket.send("ping");
                } else {
                    console.log("WebSocket 已断开，停止心跳");
                    this.resetHeartCheck();
                }
            }, 30000);
        },

        stopHeartCheck() {
            this.resetHeartCheck();
            if (this.websocket) {
                this.websocket.close();
                this.websocket = null;
            }
        },
    },

    beforeDestroy() {
        this.stopHeartCheck();
    },

};
